import { useMemo } from 'react';
import { usePartnerWidgetFeatureFlags } from 'utils/partnerIntegrationsWidget/usePartnerWidgetFeatureFlags';
import { useCurrentUser, userHasRole } from 'utils/user';
import { integrations } from './integrations';
/**
 * A hook that returns a list of integrations that the current user has access
 * to.
 */
export const useIntegrations = () => {
    const { user } = useCurrentUser();
    const partnerWidgetFeatureFlags = usePartnerWidgetFeatureFlags();
    return useMemo(() => Object.keys(integrations)
        .filter((key) => userHasRole(user, integrations[key].minimumRole))
        .filter((key) => integrations[key].integrationType === 'partnerWidget'
        ? partnerWidgetFeatureFlags[key]
        : true)
        .sort((a, b) => a.localeCompare(b))
        .reduce((obj, key) => {
        return Object.assign(Object.assign({}, obj), { [key]: integrations[key] });
    }, {}), [user, partnerWidgetFeatureFlags]);
};
